<template>
  <div>
    <div class="flex flex-col md:flex-row justify-between md:items-center mb-4">
        <h1 class="text-4xl font-bold tracking-tight text-gray-600">Brukere</h1>
        <div class="flex items-center">
          <select class="bg-white flex" :class="{ 'text-gray-500': selectedRole === -1 }" v-model="selectedRole">
            <option :value="-1" class="text-gray-900">Rolle</option>
            <option :value="0" class="text-gray-900">Administrator</option>
            <option :value="1" class="text-gray-900">Praksiskoordinator</option>
            <!-- <option :value="2" class="text-gray-900">Apotek</option> -->
            <option :value="3" class="text-gray-900">Kjedekontakt</option>
          </select>
          <search-input class="ml-4" v-model="search"></search-input>
          <router-link class="ml-4 btn btn-primary" to="brukere/opprett">Ny bruker</router-link>
          <a href="#" @click.prevent="onDelete" class="ml-4 btn btn-primary" v-if="selected.length > 0">
            <font-awesome-icon :icon="['far', 'trash']" />
          </a>
        </div>
      </div>
    <panel>
      <data-table
        :headers="headers"
        :items="filteredUsers"
        :search="search"
        :showSelect="true"
        v-model="selected"
        identifier="userId"
        @click="onClick">
      </data-table>
    </panel>
  </div>
</template>

<script>
import api from '@/api'
import _ from 'lodash'
export default {
  name: 'user-list',
  data () {
    return {
      search: '',
      selected: [],
      selectedRole: -1,
      headers: [
        { text: 'Navn', align: 'left', value: 'name' },
        { text: 'E-post', align: 'left', value: 'email' },
        { text: 'Telefon', align: 'left', nowrap: true, value: 'phone' },
        { text: 'Rolle', align: 'left', value: 'roleDisplay' },
        { text: 'Beskrivelse', align: 'left', value: 'institution' },
      ],
      users: [],
    }
  },
  computed: {
    filteredUsers () {
      return this.selectedRole === - 1 ? this.users : _.filter(this.users, u => u.role === this.selectedRole)
    }
  },
  methods: {
    onClick (user) {
      this.$router.push({ name: 'af-user-edit', params: { id: user.userId } })
    },
    async onDelete () {
      for (let i = 0; i < this.selected.length; i++) {
        await api.af.deleteUser(this.selected[i].userId)
      }
      this.$toasted.show(`${ this.selected.length } bruker${ this.selected.length > 1 ? 'e' : '' } slettet!`)
      this.users = await api.af.getUsers()
    }
  },
  async created () {
    this.users = await api.af.getUsers()
  },
  watch: {
    'selectedRole': function(val) {
      this.headers[4].text = val === -1 ? 'Beskrivelse' :
                             val === 0 ? '' :
                             val === 1 ? 'Studiested' :
                             //val === 2 ? 'Apotek' :
                             val === 3 ? 'Kjede' : ''

    }
  }
}
</script>